import React, { useState } from 'react';
import ArrayWidget from '@plone/volto/components/manage/Widgets/ArrayWidget';
import { cabeNoLimite, MAX_PUBLICAR_TAMBEM } from './limite';

interface PublicarTambemWidgetProps {
  id: string;
  value?: string[] | null;
  maxItems?: number;
  onChange: (id: string, value: string[] | null) => void;
  [key: string]: unknown;
}

/**
 * "Publicar também" da notícia: o `ArrayWidget` do core (busca no
 * vocabulário de unidades enquanto digita, "AC" ou "Acre") com o limite
 * aplicado na hora. O `ArrayWidget` só acusa o `maxItems` ao salvar, e não
 * repassa `isOptionDisabled` ao react-select — por isso a 6ª escolha é
 * descartada no `onChange`, com um aviso e o contador n/5.
 */
const PublicarTambemWidget: React.FC<PublicarTambemWidgetProps> = (props) => {
  const { id, value, onChange } = props;
  const max = props.maxItems ?? MAX_PUBLICAR_TAMBEM;
  const atual = value ?? [];
  const [recusou, setRecusou] = useState(false);

  const handleChange = (fieldId: string, nova: string[] | null) => {
    if (!cabeNoLimite(atual, nova ?? [], max)) {
      setRecusou(true);
      return;
    }
    setRecusou(false);
    onChange(fieldId, nova);
  };

  const cheio = atual.length >= max;
  const cor = cheio
    ? 'text-amber-600 dark:text-amber-400'
    : 'text-gray-500 dark:text-night-400';

  return (
    <>
      <ArrayWidget {...props} onChange={handleChange} />
      <p className={`mt-1 text-right text-xs tabular-nums ${cor}`}>
        <span aria-hidden="true">
          {atual.length}/{max}
        </span>
        <span role="status" className="sr-only">
          {recusou ? `Limite de ${max} unidades atingido.` : ''}
        </span>
      </p>
      {recusou && (
        <p
          id={`${id}-limite`}
          className="mt-1 text-xs text-red-600 dark:text-red-400"
        >
          Selecione no máximo {max} unidades. Remova uma para incluir outra.
        </p>
      )}
    </>
  );
};

export default PublicarTambemWidget;
